import { render, staticRenderFns } from "./advert-person.vue?vue&type=template&id=9bc6b774"
import script from "./advert-person.vue?vue&type=script&lang=ts"
export * from "./advert-person.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports